import React from 'react'
import { ButtonType } from '../../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { grey } from '../../../../colors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { useMutation } from '@tanstack/react-query'
import api from '../../../../utils/api'
import { type IAttribute } from '../../../../models/Attributes'
import { notification } from '../../../../components/Notifications'
import { type AxiosError, type AxiosResponse } from 'axios'

interface DeleteAttributesProps {
  selectedRow?: IAttribute
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
  refetch: () => void
}

const deleteCourseAttributes = async (attributeId: string): Promise<any> => {
  const response = await api.delete(`/api/attributes/${attributeId}/`)
  return response
}

const DeleteAttributes: React.FC<DeleteAttributesProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage, refetch }) => {
  const theme = useTheme()

  const mutation = useMutation({
    mutationFn: deleteCourseAttributes,
    onSuccess: (res: AxiosResponse) => {
      handleCloseModal?.()
      notification('Successfully deleted', { variant: 'success', subTitle: res?.data?.message })
      refetch()
    },
    onError: (error: any) => {
      console.log(error)
      setErrorMessage?.(error.message ?? 'Failed to delete the course attribute. Please try again.')
      showErrorModal?.()
    }
  })

  const handleDelete = async (): Promise<void> => {
    if (!selectedRow) return
    mutation.mutate(selectedRow.attributeId)
  }

  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
        You will not be able to recover this Course Attribute. All references to it will be deleted.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading: mutation.isPending,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteAttributes
